import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteVehicleSlice = createSlice({
  name: "DeleteVehicle",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteVehicle: (state, _) => {
      state.isLoading = true;
    },
    successDeleteVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteVehicle: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteVehicle,
  failureDeleteVehicle,
  successDeleteVehicle,
  clearDeleteVehicle,
} = DeleteVehicleSlice.actions;

export default DeleteVehicleSlice.reducer;
